const contextUIModule = {
  namespaced: true,
  modules: {},
  state: () => ({
    clipboard: { text: null, blockIds: [], parent: null, contents: [] }
  }),
  getters: {},
  mutations: {
    setClipboard(state, val) {
      state.clipboard = val;
    }
  }
};

export default contextUIModule;
